var render, staticRenderFns
import script from "./panelBlock.vue?vue&type=script&lang=js"
export * from "./panelBlock.vue?vue&type=script&lang=js"
import style0 from "./panelBlock.vue?vue&type=style&index=0&id=490c1a20&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports